export default "__VITE_ASSET__CJw6kjVc__"